export const PDF_NAME = 'LUCIOLE_PORTFOLIO_VOEUX_2025_v18092026.pdf';
export const PDF_NAME_MOBILE = 'LUCIOLE_PORTFOLIO_VOEUX_2025_v18092026.pdf';
export const PDF_NAME_HR = 'LUCIOLE_PORTFOLIO_VOEUX_2025_v18092026.pdf';

export const SKIP_ANIMATION_STORAGE_KEY = 'SKIP_ANIMATION';

export const MENU_DESKTOP_WIDTH = 300;
export const MENU_MOBILE_HEADER_HEIGHT = 85;
export const MENU_MOBILE_FOOTER_HEIGHT = 75;
export const NAVIGATION_HEIGHT = 52;
export const MOBILE_NAVIGATION_HEIGHT = 40;
export const PDF_PAGE_RATIO = 339 / 190;
export const MODE_SINGLE_PAGE = false;
export const TITLE_LOADER = 'LUCIOLE';
// export const PRESENTATION_TEXT = 'Chez Luciole, nous donnons vie à vos rapports d\'activités en transformant chaque donnée en une histoire visuelle captivante, reflétant l\'essence unique de votre entreprise.';
// export const PRESENTATION_TEXT = 'Chez Luciole, nous créons des expériences événementielles inoubliables en concevant des stands qui capturent l'âme de votre marque.Chaque détail est pensé pour engager, émerveiller et laisser une empreinte durable dans l’esprit de vos visiteurs.';
export const PRESENTATION_TEXT = "Les vœux se travaillent afin d’être souhaité avec sincérité, sur le bon ton et dans le plus beau des écrins. Aussi cultivons-nous le sens et le design afin de créer de belles expériences visuelles.";
export const DOWNLOAD_TEXT = 'Télécharger ce portfolio';
export const SHARE_TEXT = 'Partager ce portfolio';
export const SHARE_TEXT_FACEBOOK = 'Partager sur Facebook';
export const SHARE_TEXT_X = 'Partager sur X';
export const SHARE_TEXT_LINKEDIN = 'Partager sur LinkedIn';
export const SHARE_TEXT_COPYPASTE = 'Copier le lien dans le presse-papier';
export const SHARE_TEXT_COPYPASTE_SUCCESS = 'Lien copié dans le presse papier';

export const FOLLOW_TEXT = 'NOUS SUIVRE';

export const TEXT_LINKS = {
  4: {
    client: "GROUPE RATP",
    secteur: "Mobilité urbaine",
    miles: "2024 - 2025",
    // concept: "Quand pour parler des métiers du Groupe partout dans le monde, la direction artistique se fait accompagner par l’I.A pour créer un visuel aux innombrables entrées…",
    // livrable: "Une carte deux volets (4 langues) et un motion design de 13’’",
  },
  5: {
    client: "GROUPE RATP",
    secteur: "Mobilité urbaine",
    miles: "2024 - 2025",
    // concept: "Quand pour parler des métiers du Groupe partout dans le monde, la direction artistique se fait accompagner par l’I.A pour créer un visuel aux innombrables entrées…",
    // livrable: "Une carte deux volets (4 langues) et un motion design de 13’’",
  },
  6: {
    client: "Agence française de lutte contre le dopage",
    secteur: "Autorité administrative",
    miles: "2021",
    // concept: "Un peu de gaité et de légèreté dans un secteur qui ne l’est pas toujours !",
    // livrable: "Une carte deux volets et un motion design.",
  },
  7: {
    client: "Expertise France",
    secteur: "Expertise internationale au développement",
    miles: "Depuis 2017",
    // concept: "Un carton gris épais, une mappemonde traitée en pointillés et vernis « braille », et une impression à chaud en Pantone bleu métallique.",
  },
  8: {
    client: "CEA",
    secteur: "Recherche",
    miles: "2023",
    // concept: "Un visuel de chiffres et de trames « CEA » sur un papier ensemencé.",
    // livrable: "Une carte imprimée et une vidéo en motion design pour raconter le CEA aujourd’hui.",
  },
  9: {
    client: "GROUPE NOVARC",
    secteur: "Industrie",
    miles: "2023",
    // concept: "De la géométrie typographique animée pour accompagner le lancement du nouveau site, des nouveaux logotypes et d’un nouveau Brandbook (design by LUCIOLE).",
  },
  10: {
    client: "Maisons & Domaines Henriot",
    secteur: "Vins & spiritueux",
    miles: "2018 à 2021",
    // livrable: "Des cartes imprimées en dorure à chaud. Un coffret VIP de tirages photographiques des domaines.",
  },
  11: {
    client: "Maisons & Domaines Henriot",
    secteur: "Vins & spiritueux",
    miles: "2018 à 2021",
    // livrable: "Des cartes imprimées en dorure à chaud. Un coffret VIP de tirages photographiques des domaines.",
  },
  12: {
    client: "BOURDON AVOCATS",
    secteur: "Avocats à la cour",
    miles: "2006 à 2020",
    // // concept: "13 concepts de vœux réalisés en 13 ans ! Comme ici en 2019, avec de la typographie bien ordonnée et une fabrication embossée.",
  },
  13: {
    client: "Agence de la biomédecine",
    secteur: "Agence relevant du ministère de la Santé",
    miles: "Depuis 2016",
    // concept: "Des pictogrammes tout juste livrés avec le Brand Book, qui racontent les métiers et les promesses de cette grande institution de santé publique.",
    // livrable: "Une carte très simple, avec un argent à chaud sur un beau papier de création. Mais aussi une carte animée et autres talons de mail.",
  },
  14: {
    client: "Grand Paris Aménagement",
    secteur: "Aménagement urbain",
    miles: "2017 à 2021",
    // concept: "De belles lettres colorées et animées.",
    // livrable: "Une animation vidéo et une belle carte imprimée.",
  },
  15: {
    client: "BRUCHER, THIELTGEN & PARTNERS",
    secteur: "Avocats à la cour",
    miles: "2024",
    // concept: "Une première collaboration, prélude à la refonte de l’identité du cabinet l’année suivante.",
  },
  16: {
    client: "SCOR",
    secteur: "Société de gestion",
    miles: "2019",
    // concept: "Packaging sur mesure avec forme à la découpe et papiers de création. « Vous reprendrez bien un chocolat ? »",
  },
  17: {
    client: "Union Sociale pour l’Habitat",
    secteur: "Logement social",
    miles: "2019 à 2023",
    // concept: "Différent chaque année et toujours à la hauteur des attentes de ce client exigeant et engagé !",
  },
  18: {
    client: "Union Sociale pour l’Habitat",
    secteur: "Logement social",
    miles: "2019 à 2023",
    // concept: "Différent chaque année et toujours à la hauteur des attentes de ce client exigeant et engagé !",
  },
  19: {
    client: "Union Sociale pour l’Habitat",
    secteur: "Logement social",
    miles: "2019 à 2023",
    // concept: "Différent chaque année et toujours à la hauteur des attentes de ce client exigeant et engagé !",
  },
  20: {
    client: "FIDAL",
    secteur: "Avocats",
    miles: "2023",
    // concept: "Une carte élégante, un coffret VIP, un motion design.",
  },
  21: {
    client: "LUCIOLE",
    secteur: "Agence conseil de design de communication",
    miles: "Depuis 1991",
    // concept: "Il diffère chaque année et nous testons de nouvelles idées et options de fabrication.",
  },
};

export const LINKS = {
  5: {
    url: 'RATP_Cartevoeux_Anim_GIFF_ENG_LOGO.gif',
    isGif: true,
  },
  9: {
    url: 'novarc-01.mov',
    isVideo: true,
  },
  14: {
    url: 'grand-paris-amenagement-01.mp4',
    isVideo: true,
  },
  16: {
    title: 'USH-2019_2023',
    url: 'ush-01.mp4',
    isVideo: true,
  },
  17: {
    title: 'USH-2022',
    url: 'ush-02.mp4',
    isVideo: true,
  },
  18: {
    url: 'USH-2023-GIF-1920x1080-V2.gif',
    isGif: true,
  },
}

const SHARE_URL = encodeURIComponent(window.location.href);
const SHARE_DESCRIPTION = encodeURIComponent('Luciole');
const SHARE_TITLE = encodeURI('Luciole');
export const WEBSITE_URL = 'https://luciole.com/';
export const FACEBOOK_SHARE_PARAMS = `http://www.facebook.com/share.php?u=${SHARE_URL}`;
export const X_SHARE_PARAMS = `http://x.com/intent/tweet?text=${SHARE_DESCRIPTION}&url=${SHARE_URL}`;
export const LINKEDIN_SHARE_PARAMS = ` https://www.linkedin.com/shareArticle?mini=true&url=${SHARE_URL}&title=${SHARE_TITLE}&summary=${SHARE_DESCRIPTION}`;
export const LINKEDIN_URL = 'https://www.linkedin.com/company/agence-luciole';

const CONFIG = {
  PDF_NAME,
  SKIP_ANIMATION_STORAGE_KEY,
  MENU_DESKTOP_WIDTH,
  MENU_MOBILE_HEADER_HEIGHT,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_PAGE_RATIO,
  NAVIGATION_HEIGHT,
  LINKS,
  MOBILE_NAVIGATION_HEIGHT,
  FACEBOOK_SHARE_PARAMS,
  X_SHARE_PARAMS,
  WEBSITE_URL,
};

export default CONFIG;
